import { useRef, useState } from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import styled from "styled-components";
import { MdArrowBack, MdArrowForward } from "react-icons/md";

import SectionTitle from "./SectionTitle";
import PText from "./PText";
import testimonials from "../assets/data/testimonials";
import Reveal from "./Reveal";
import { glass } from "../styles/glass";

const TestimonialsSectionStyles = styled.div`
  padding: 10rem 0;
  text-align: center;
  .testimonial__wrapper {
    position: relative;
    max-width: 700px;
    margin: 0 auto;
  }
  .testimonial__info {
    ${glass}
    width: 100%;
    height: fit-content;
    padding: 3.4rem 3rem;
    border-radius: var(--radius-lg);
    margin-top: 5rem;
  }
  .testimonial__desc {
    .para {
      text-align: center;
    }
  }
  .testimonial__name {
    margin-top: 4rem;
    font-family: "Montserrat Bold";
    font-size: 2.2rem;
  }
  .testimonial__title {
    font-size: 1.6rem;
    margin-top: 0.3rem;
  }
  .arrows {
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 30px;
      pointer-events: none;
    }
    .next,
    .prev {
      margin: 0 0.5rem;
      width: fit-content;
      background: var(--glass-bg-strong);
      -webkit-backdrop-filter: blur(14px) saturate(160%);
      backdrop-filter: blur(14px) saturate(160%);
      border: 1px solid var(--glass-border);
      box-shadow: var(--glass-rim), 0 12px 28px -14px rgba(0, 0, 0, 0.7);
      padding: 0.6rem 2.2rem;
      border-radius: 999px;
      cursor: pointer;
      transition: transform 0.7s var(--ease-smooth), background 0.6s var(--ease-smooth),
        border-color 0.6s var(--ease-smooth);
      &:hover {
        background: rgba(99, 209, 191, 0.2);
        border-color: var(--glass-border-hover);
        transform: translateY(-2px) scale(1.04);
      }
      &:active {
        transform: scale(0.96);
        transition-duration: 0.2s;
      }
    }
  }
  .fade-enter {
    opacity: 0;
    transform: scale(0.96);
  }
  .fade-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: 250ms ease-in opacity;
    transition-property: opacity, transform;
  }
  .fade-exit {
    opacity: 1;
    transform: scale(1);
  }
  .fade-exit-active {
    opacity: 0;
    transform: scale(0.96);
    transition: 250ms ease-in opacity;
    transition-property: opacity, transform;
  }
`;

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeSlide = testimonials[activeIndex];
  const nodeRef = useRef(null);

  function handlePrev() {
    if (activeIndex >= testimonials.length - 1) {
      setActiveIndex(0);
    } else {
      setActiveIndex((oldIndex) => oldIndex + 1);
    }
  }

  function handleNext() {
    if (activeIndex <= 0) {
      setActiveIndex(testimonials.length - 1);
    } else {
      setActiveIndex((oldIndex) => oldIndex - 1);
    }
  }

  return (
    <TestimonialsSectionStyles>
      <div className="container">
        <SectionTitle
          heading="Programming Quotes"
          subheading="Choice of my favourite programming quotes"
        />
        <Reveal>
        <div className="testimonial__wrapper">
          <SwitchTransition>
            <CSSTransition
              key={activeSlide.id}
              timeout={300}
              classNames="fade"
              nodeRef={nodeRef}
            >
              <div ref={nodeRef} className="testimonial__info glass">
                <div className="testimonial__desc">
                  <PText>{activeSlide.desc}</PText>
                </div>
                <h2 className="testimonial__name">{activeSlide.name}</h2>
                <p className="testimonial__title">
                  {activeSlide.title}, <br /> {activeSlide.org}
                </p>
              </div>
            </CSSTransition>
          </SwitchTransition>
        </div>
        <div className="arrows">
          <div
            className="prev"
            onClick={handlePrev}
            role="button"
            tabIndex={0}
            onKeyDown={handlePrev}
          >
            <MdArrowBack />
          </div>
          <div
            className="next"
            onClick={handleNext}
            role="button"
            tabIndex={0}
            onKeyDown={handleNext}
          >
            <MdArrowForward />
          </div>
        </div>
        </Reveal>
      </div>
    </TestimonialsSectionStyles>
  );
}
